import React from "react";
import FeatureHeader from "../components/FeatureHeader";
import "./Donate.css";

// Givebutter handles the payment and the donor's tax receipt. The widget
// library that renders this element is loaded in public/index.html; the ID
// comes from the campaign's Sharing > Widgets page in Givebutter.
const GIVEBUTTER_WIDGET_ID = "LYOvPd";

export default function Donate() {
  return (
    <div className="donate">
      <FeatureHeader badge="Support NICU families" icon="heart" title="Donate">
        Every gift helps a NICU family with the practical and emotional weight
        of their journey.
      </FeatureHeader>

      <section>
        <div className="container donate-layout">
          <div className="donate-panel">
            <givebutter-widget id={GIVEBUTTER_WIDGET_ID}></givebutter-widget>
          </div>

          <div className="donate-side">
            <h3>Where your gift goes</h3>
            <p>
              The Bug and Frog Foundation was started by NICU mothers who know
              firsthand what these families need, because they needed it too.
              Your gift goes to direct, practical support:
            </p>
            <ul>
              <li>
                <strong>Financial support.</strong> Subsidies for parking, meals,
                and other unexpected costs. Most financial programs require a NICU
                stay of at least 30 days before they help; we help regardless of
                length of stay.
              </li>
              <li>
                <strong>Preemie care packages.</strong> Preemie-sized clothing and
                blankets, bottles, pacifiers, formula, and gentle skincare for baby
                and caregiver.
              </li>
              <li>
                <strong>Social program assistance.</strong> One-on-one help applying
                for WIC and Medicaid, gathering documents, and keeping up with
                deadlines and renewals.
              </li>
              <li>
                <strong>Feeding support.</strong> Replacement breast pump parts and
                feeding supplies.
              </li>
            </ul>
            <p>
              The Bug and Frog Foundation is a 501(c)(3) nonprofit, so your
              donation may be tax-deductible.
            </p>
            <p className="donate-side-note">
              Prefer to mail a check or give another way? Reach out at{" "}
              <a href="mailto:info@bugandfrog.org">info@bugandfrog.org</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}
